module.exports = __webpack_public_path__ + "static/media/ICBT 1b1.57924dc0.jpg";